import PickupStoreSelector from 'features/store/pages/pickup-store-selector';

export default function PickupStoreSelectorPage() {
  return <PickupStoreSelector />;
}
